import React from "react";
import { Inbox } from "lucide-react";

export function EmptyState({ icon: Icon = Inbox, title, description, action }) {
    return (
        <div className="empty-state" data-testid="empty-state">
            <Icon className="empty-state-icon" />
            <h3 className="empty-state-title">{title}</h3>
            {description && <p className="empty-state-description">{description}</p>}
            {action && <div className="mt-4">{action}</div>}
        </div>
    );
}
